import React, { useEffect, useMemo, useState } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import templateService from '../../service/template.service';

const resolveDocumentTypeName = (row, documentTypes) => {
  if (row?.documentType?.name) return row.documentType.name;
  if (row?.documentTypeName) return row.documentTypeName;
  return documentTypes.find((item) => Number(item.documentTypeId) === Number(row?.documentTypeId))?.name || '';
};

const resolveFormName = (row, forms) => {
  if (row?.form?.subMenuName) return row.form.subMenuName;
  if (row?.subMenu?.subMenuName) return row.subMenu.subMenuName;
  if (row?.formName) return row.formName;
  return forms.find((item) => Number(item.subMenuId) === Number(row?.formId))?.subMenuName || '';
};

const resolveLanguageName = (row, languages) => {
  if (row?.language?.name) return row.language.name;
  if (row?.languageName) return row.languageName;
  return languages.find((item) => item.code === row?.languageCode)?.name || row?.languageCode || '';
};

const resolveTemplateTypeName = (value) => {
  if (value === 'email') return 'E-mail';
  if (value === 'text') return 'Szöveg';
  return value ?? '';
};

const TemplateReports = ({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  documentTypes,
  forms,
  languages,
}) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled, setRowSelectionModel]);

  const getList = (gridState) => {
    templateService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = useMemo(() => {
    return dataGridPremiumColumns([
      {
        field: 'name',
        headerName: 'Név',
        type: 'string',
      },
      {
        field: 'templateType',
        headerName: 'Típus',
        type: 'string',
        renderCell: (data) => resolveTemplateTypeName(data.row.templateType),
      },
      {
        field: 'documentTypeId',
        headerName: 'Bizonylattípus',
        type: 'string',
        renderCell: (data) => resolveDocumentTypeName(data.row, documentTypes),
      },
      {
        field: 'formId',
        headerName: 'Form',
        type: 'string',
        renderCell: (data) => resolveFormName(data.row, forms),
      },
      {
        field: 'languageCode',
        headerName: 'Nyelv',
        type: 'string',
        renderCell: (data) => resolveLanguageName(data.row, languages),
      },
      {
        field: 'subject',
        headerName: 'Tárgy',
        type: 'string',
      },
    ]);
  }, [documentTypes, forms, languages]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.template}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        templateService.getItem(rowData.row.id).then((data) => {
          setSelectedValues(data);
        });
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
      getRowId={(row) => row.id}
    />
  );
};

export default TemplateReports;
